import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeletionListComponent } from './deletion-list.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [DeletionListComponent],
  exports: [DeletionListComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule],
})
export class DeletionListModule {}
